export const FETCH_QUICK_BOOKS_SETTINGS = 'FETCH_QUICK_BOOKS_SETTINGS';
export const STORE_QUICK_BOOKS_ACCOUNT_MAP = 'STORE_QUICK_BOOKS_ACCOUNT_MAP';
export const DISCONNECT_QUICK_BOOKS_ACCOUNT = 'DISCONNECT_QUICK_BOOKS_ACCOUNT';
